import { el, clear, debounce } from '../../utils/dom.js';
import { Loans } from '../../api/resources.js';
import { dataTable } from '../../components/table.js';
import { statusBadge } from '../../components/badge.js';
import { fmtDateTime } from '../../utils/format.js';
import { ok, err } from '../../components/toast.js';

const STATUSES = ['', 'activo','parcial','vencido','devuelto','perdido','danado'];

export default async function LoansListPage(outlet) {
  clear(outlet);
  const state = { page: 1, q: '', status: '' };

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Prestamos'),
    el('div', { class: 'flex gap-2' },
      el('button', { class: 'btn', onclick: async () => {
        try { const r = await Loans.sweepOverdue(); ok(`${r.updated_count} marcados vencidos`); refresh(); }
        catch (ex) { err(ex.message); }
      } }, 'Marcar vencidos'),
      el('a', { href: '#/loans/new', class: 'btn primary' }, '+ Nuevo prestamo'),
    ),
  ));

  const search = el('input', { class: 'input grow', placeholder: 'Buscar por codigo o responsable...',
    oninput: debounce((e) => { state.q = e.target.value; state.page = 1; refresh(); }, 300) });
  const statusSel = el('select', { class: 'select', onchange: (e) => { state.status = e.target.value; state.page = 1; refresh(); } },
    ...STATUSES.map((s) => el('option', { value: s }, s || 'Todo estado')));
  outlet.appendChild(el('div', { class: 'toolbar' }, search, statusSel));

  const host = el('div');
  outlet.appendChild(host);

  async function refresh() {
    host.innerHTML = '<div class="empty">Cargando...</div>';
    try {
      const res = await Loans.list({ page: state.page, limit: 25, q: state.q || undefined, status: state.status || undefined });
      host.replaceChildren(dataTable({
        columns: [
          { key: 'code',           label: 'Codigo',        render: (r) => el('a', { href: `#/loans/${r.id}`, class: 'text-mono text-bold' }, r.code) },
          { key: 'responsible_name', label: 'Responsable' },
          { key: 'status',         label: 'Estado', render: (r) => statusBadge(r.status) },
          { key: 'start_date',     label: 'Inicio',  render: (r) => fmtDateTime(r.start_date) },
          { key: 'expected_return_date', label: 'Vence', render: (r) => fmtDateTime(r.expected_return_date) },
          { key: 'actual_return_date',   label: 'Devuelto', render: (r) => r.actual_return_date ? fmtDateTime(r.actual_return_date) : '—' },
        ],
        rows: res.data || [],
        empty: 'Sin prestamos.',
        pagination: res.pagination ? { page: res.pagination.page, pages: res.pagination.pages, onPage: (p) => { state.page = p; refresh(); } } : null,
      }));
    } catch (ex) {
      host.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
    }
  }
  refresh();
}
